import { Badge, TextInput } from "@mantine/core";
import dayjs from "dayjs";
import { DataTable } from "mantine-datatable";
import { useEffect, useState } from "react";

const Pagination = ({ data, itemsPerPage, rol, queryEstado }) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Calcular el número total de páginas
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const columns = [
    ...(rol === "1"
      ? [
          {
            accessor: "acciones",
            title: "⚙️",
            textAlignment: "center",
            render: (row) => acciones(row),
          },
        ]
      : []),
    {
      accessor: "create_at",
      title: "Fecha",
      textAlignment: "center",
      render: ({ create_at }) => {
        const day = dayjs(create_at)
          .tz("America/Guayaquil")
          .format("DD/MM/YYYY HH:mm");
        return <span>{day}</span>;
      },
    },
    {
      accessor: "pre_periodos.nombre",
      title: "Periodo",
      textAlignment: "center",
    },
    ...(rol === "1"
      ? [
          {
            accessor: "pre_usuarios.code",
            title: "Cod reporte",
            textAlignment: "center",
            render: ({ pre_usuarios, create_at }) => {
              return (
                <span>{`${
                  pre_usuarios.code.length === 1
                    ? `000${pre_usuarios.code}`
                    : pre_usuarios.code.length === 2
                    ? `00${pre_usuarios.code}`
                    : pre_usuarios.code.length === 3
                    ? `0${pre_usuarios.code}`
                    : pre_usuarios.code
                }${dayjs(create_at).format("YYYYMMDDHHmmss")}4008`}</span>
              );
            },
          },
        ]
      : []),
    {
      accessor: "pre_usuarios",
      title: "Codigo",
      textAlignment: "center",
      render: ({ pre_usuarios }) => {
        return (
          <span>
            {pre_usuarios.code.length === 1
              ? `000${pre_usuarios.code}`
              : pre_usuarios.code.length === 2
              ? `00${pre_usuarios.code}`
              : pre_usuarios.code.length === 3
              ? `0${pre_usuarios.code}`
              : pre_usuarios.code}
          </span>
        );
      },
    },
    ...(rol === "1"
      ? [
          {
            accessor: "pre_usuarios.apellidos",
            title: "Apellidos",
            textAlignment: "left",
          },
          {
            accessor: "pre_usuarios.nombres",
            title: "Nombres",
            textAlignment: "left",
          },
        ]
      : []),

    {
      accessor: "pre_usuarios.pre_tipos_usuarios.tipo",
      title: "Tipo",
      textAlignment: "center",
    },
    {
      accessor: "comida",
      title: "Comida",
      textAlignment: "left",
    },

    {
      accessor: "client_estado",
      title: "Estado",
      textAlignment: "center",
      render: ({ client_estado }) => {
        return (
          <Badge
            color={
              client_estado === "PENDIENTE"
                ? "orange"
                : client_estado === "CONFIRMADO"
                ? "green"
                : "red"
            }
            variant="filled"
          >
            {client_estado === "INCONPLETO" ? "INCOMPLETO" : client_estado}
          </Badge>
        );
      },
      filter: (
        <TextInput
          placeholder="Filtrar por estado..."
          value={queryEstado}
          onChange={(e) => null}
        />
      ),
      filtering: queryEstado !== "",
    },
  ];
  // Obtener los elementos de la página actual
  const getcurrrent = () => {
    let currentData = data.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
    console.log("aqui esta la data curretn");
    console.log(currentData);
    return currentData;
  };

  useEffect(() => {
    getcurrrent();
  }, []);

  const acciones = (row) => {
    return (
      <span
        style={{
          cursor: "pointer",
          padding: "2px 2px",
        }}
        onClick={(e) => {
          e.preventDefault();
        }}
      >
        <i className="fa fa-close text-danger" />
      </span>
    );
  };

  // Cambiar a una página específica
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="h-100">
      <DataTable
        borderRadius="md"
        className="bordecompleto"
        style={{ zIndex: 0 }}
        highlightOnHover
        noRecordsText="No se encontraron datos"
        columns={columns}
        records={getcurrrent()}
        withColumnBorders
        totalRecords={data.length}
        recordsPerPage={itemsPerPage}
        page={currentPage}
        onPageChange={goToPage}
      />
      {/*  <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">First</th>
            <th scope="col">Last</th>
            <th scope="col">Handle</th>
          </tr>
        </thead>
        <tbody>
          {getcurrrent().map((item, index) => (
            <tr key={index}>
              <th>{ dayjs(item.create_at).format("YYYY-MM-DD HH:mm")}</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          ))}
        </tbody>
      </table> */}
      {/* 
      <div>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            className="btn btn-primary"
            key={index}
            onClick={() => goToPage(index + 1)}
            disabled={currentPage === index + 1}
          >
            {index + 1}
          </button>
        ))}
      </div> */}
    </div>
  );
};

export default Pagination;
